import classNames from 'classnames'
import dayjs from 'dayjs'
import DOMPurify from 'dompurify'
import { FC, useState } from 'react'
import { InView } from 'react-intersection-observer'

import styles from './Notifications.module.scss'
import { NoticeHistoryItem } from './types/noticeHistory'

interface INotificationItem {
  item: NoticeHistoryItem
  markAsReded: (a: number) => void
}

// уведомление
export const NotificationItem: FC<INotificationItem> = ({
  item,
  markAsReded,
}) => {
  const [firstRender, setFirstRender] = useState(true)

  const markAsReadNotice = (inView: boolean) => {
    if (!item.isRead && firstRender && inView) {
      markAsReded(item.id)
      setFirstRender(false)
    }
  }

  //делаем ссылки кликабельными
  const replaceUrlLinks = (text: string) => {
    const urlRegex = /\[url=(.*?)\](.*?)\[\/url\]/g
    return text.replace(urlRegex, '<a href="$1">$2</a>')
  }
  const message = DOMPurify.sanitize(replaceUrlLinks(item.message), {
    ALLOWED_TAGS: ['a', 'b', 'i', 'br', 'strong', 'em'],
    ALLOWED_ATTR: ['href', 'target'],
  })

  return (
    <InView
      as='div'
      onChange={inView => markAsReadNotice(inView)}
      threshold={0.8}
      className={classNames(styles.notice, !item.isRead ? styles.active : '')}
    >
      <span
        className='default-text'
        dangerouslySetInnerHTML={{ __html: message }}
      />
      <span className='caption'>
        {dayjs(item.receivedAt).format('DD.MM.YYYY HH:mm')}
      </span>
    </InView>
  )
}
